import React from "react";

const LEADERS = [
  {
    name: "Jake Bainbridge",
    role: "Founder & Executive Director",
    bio: `founded Midnight Sun Working Dog Coalition after more than 15 years of therapy dog visitation and crisis-intervention experience. Over time, Jake observed a repeated pattern across schools, treatment settings, and community environments: calming supports were often introduced only after an escalation had already occurred. This reactive approach had become standard practice. Through direct experience, Jake recognized that when a calming mechanism was introduced earlier — as a preventive, stabilizing presence — the escalation often did not occur, or its intensity was significantly reduced.`,
    bio2: `MSWDC was developed to help shift that standard by placing regulated, non-clinical animal-assisted support at the beginning of the escalation cycle rather than at the end. At its core, MSWDC exists to be the calm before the storm: helping people self-regulate, supporting safer environments, and reducing the likelihood that distress turns into crisis.`,
  },
];

export default function Leadership() {
  return (
    <section data-testid="leadership-section" className="bg-white border-y border-slate-200">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-8 mb-14">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="brand-rule" />
              <span className="overline">The People</span>
            </div>
            <h2 className="mt-6 font-display font-black text-3xl md:text-5xl tracking-tight leading-[1.05] text-slate-900">
              Stewards of the doctrine.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 md:pt-12">
            <p className="text-slate-600 leading-relaxed">
              MSWDC is led by people selected for character over charisma — measured by
              ethical consistency, emotional regulation, and devotion to the work.
            </p>
          </div>
        </div>

        <div className="space-y-20">
          {LEADERS.map((leader, i) => (
            <article
              key={leader.name}
              data-testid={`leader-${i}`}
              className="grid grid-cols-12 gap-8 md:gap-16"
            >
              <div className="col-span-12 md:col-span-4">
                <div className="aspect-[4/5] bg-slate-100 border border-slate-200 flex items-center justify-center">
                  <span className="font-display font-black text-6xl text-slate-300 select-none">
                    {leader.name.split(" ").map((n) => n[0]).join("")}
                  </span>
                </div>
                <div className="mt-5">
                  <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-amber-600">
                    {leader.role}
                  </div>
                  <h3 className="mt-2 font-display font-black text-2xl md:text-3xl text-slate-900">
                    {leader.name}
                  </h3>
                </div>
              </div>

              <div className="col-span-12 md:col-span-8 md:pt-2">
                <p className="text-slate-700 text-base md:text-lg leading-relaxed">
                  <span className="font-display font-bold text-slate-900">{leader.name}</span>{" "}
                  {leader.bio}
                </p>
                <p className="mt-5 text-slate-700 text-base md:text-lg leading-relaxed">
                  {leader.bio2}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-slate-200 max-w-2xl">
          <p className="text-sm text-slate-500 leading-relaxed">
            Additional team and board biographies will be published as the Coalition's
            governance structure is publicly formalized.
          </p>
        </div>
      </div>
    </section>
  );
}
